import { render, staticRenderFns } from "./MakeOwned.vue?vue&type=template&id=17208fef&scoped=true&lang=pug&"
import script from "./MakeOwned.vue?vue&type=script&lang=js&"
export * from "./MakeOwned.vue?vue&type=script&lang=js&"
import style0 from "./MakeOwned.vue?vue&type=style&index=0&id=17208fef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17208fef",
  null
  
)

export default component.exports